export const GET_DASHBOARD_RESPONSIBLE_BOX = 'GET_DASHBOARD_RESPONSIBLE_BOX';
export const LOADING_DASHBOARD_RESPONSIBLE_BOX = 'LOADING_DASHBOARD_RESPONSIBLE_BOX';
export const DASHBOARD_ERROR = 'DASHBOARD_ERROR';